import type { OrgModelProjection } from '../models/OrgModelProjection';

export class OrgProjectionIncompleteError extends Error {
  readonly code = 'ORG_PROJECTION_INCOMPLETE';

  constructor(readonly lane: 'entities' | 'relationships') {
    super(`Atlas ${lane} projection is incomplete; narrow the view or retry before rendering or exporting the chart`);
    this.name = 'OrgProjectionIncompleteError';
  }
}

/** Redaction is a legitimate caller-specific view; pagination is not a whole chart. */
export function orgProjectionCompletenessError(
  model: Pick<OrgModelProjection, 'completeness'> | null | undefined,
): OrgProjectionIncompleteError | null {
  if (!model) return null;
  for (const lane of ['entities', 'relationships'] as const) {
    const completeness = model.completeness?.[lane];
    if (!completeness || completeness.hasMore || completeness.truncationReason === 'record_cap') {
      return new OrgProjectionIncompleteError(lane);
    }
  }
  return null;
}
